export default {"src":"/_next/static/media/partner18.d8463e9c.svg","height":70,"width":123,"blurWidth":0,"blurHeight":0};